import { Team } from '../../models';
import CacheableJson from '../CacheableJson';

/**
 * @desc Rankings
 * This Overall Ladderer Collection
 */
export class CoreOverallLadder extends CacheableJson {
	get model() {
		return Team;
	}

	setLeagueOverallLadderUrl() {
		throw new Error("Need set url for showLeagueOverallLadder method");
	}

	showLeagueOverallLadder(data = {}) {
		this.setLeagueOverallLadderUrl();
		return this.fetch({ data }).then(response => {
			let count_teams = response.result.length;
			this.trigger('response:overall:teams:count', count_teams);
		});
	}

	setOverallLadderUrl() {
		throw new Error("Need set url for showOverallLadder method");
	}

	showOverallLadder(data = {}) {
		this.setOverallLadderUrl();
		return this.fetch({ data }).then(response => {
			let count_teams = response.result.length;
			this.trigger('response:overall:teams:count', count_teams);
		});
	}
}

export default CoreOverallLadder;